import { render, staticRenderFns } from "./TariffModal.vue?vue&type=template&id=6aa6c2b0&"
import script from "./TariffModal.vue?vue&type=script&lang=ts&"
export * from "./TariffModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports